export default ({ columnUnit, columnTotal, columnPerc }) => (operation) => (item) => {
  const fieldValue = getFieldValue(operation, item)
  const operatedValue = getOperatedValue(fieldValue, operation)
  const arrResult = calculateTotalAndPerc({
    columnUnit,
    columnTotal,
    columnPerc,
    operatedValue,
    item
  })

  return arrResult
}

const calculateTotalAndPerc = ({ columnUnit, columnTotal, columnPerc, operatedValue, item }) => {
  const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
  const total = Number(operatedValue) * quantity
  const perc = Number(((operatedValue * 100) / item.quoted.price) - 100)
  return [
    {
      quoteId: item.itemId,
      column: columnUnit,
      value: Number(operatedValue)
    },
    {
      quoteId: item.itemId,
      column: columnTotal,
      value: total
    },
    {
      quoteId: item.itemId,
      column: columnPerc,
      value: perc
    }
  ]
}

const getFieldValue = ({ fieldName }, item) => {
  switch (fieldName) {
    case 'CUSTO':
      return item.quoted.price
    case 'ESTIMADO':
      return item.itemInfo.estimatedPrice
    case 'CMED':
      return item.quoted.cmedPrice
    case 'MÁXIMO':
      const cmedPrice = item.quoted.cmedPrice && item.quoted.cmedPrice > 0 && item.quoted.cmedPrice
      const estimatedPrice = item.itemInfo.estimatedPrice && item.itemInfo.estimatedPrice > 0 && item.itemInfo.estimatedPrice
      if (!cmedPrice && estimatedPrice) {
        return estimatedPrice
      } else if (cmedPrice && !estimatedPrice) {
        return cmedPrice
      } else {
        return cmedPrice < estimatedPrice ? cmedPrice : estimatedPrice
      }
    default:
      return item.quoted.price
  }
}

const getOperatedValue = (fieldValue, { operator, value, valueType }) => {
  let stringOperation = fieldValue
  const currencyValue = convertCurrencyToNumber(value)

  let calcOperator = operator
  if (calcOperator === '±') {
    const o = Math.floor(Math.random() * 2) + 1
    calcOperator = o === 1 ? '+' : '-'
  }

  let calculated = 0
  switch (valueType) {
    case 'R$':
      stringOperation += `${calcOperator}${currencyValue}`
      calculated = addbits(stringOperation)
      return calculated.toFixed(3)
    case '%':
      const perc = getPercentualValue(fieldValue, currencyValue)
      stringOperation += `${calcOperator}${perc}`
      calculated = addbits(stringOperation)
      return calculated.toFixed(3)
    case 'R$ V':
      const variableCurencyValue = ((Math.random() * currencyValue)).toFixed(2)
      stringOperation += `${calcOperator}${variableCurencyValue}`
      calculated = addbits(stringOperation)
      return calculated.toFixed(3)
    case '% V':
      const variablePercValue = ((Math.random() * currencyValue)).toFixed(0)
      const percV = getPercentualValue(fieldValue, variablePercValue)
      stringOperation += `${calcOperator}${percV}`
      calculated = addbits(stringOperation)
      return calculated.toFixed(3)
    default:
      calculated = addbits(stringOperation)
      return calculated.toFixed(3)
  }
}

function getPercentualValue (fieldValue, value) {
  return fieldValue * (value / 100)
}

function addbits (s) {
  let total = 0
  const a = s.match(/[+-]*(\.\d+|\d+(\.\d+)?)/g) || []

  while (a.length) {
    total += parseFloat(a.shift())
  }
  return total
}

function convertCurrencyToNumber (v) {
  return v && Number(v
    .toString()
    .replace('.', '')
    .replace(',', '.'))
}



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/CalculateDynamicSaleFilter.js